export class RepoError<T = any> extends Error {
  name = 'RepoError'

  code: Nullable<string>
  status: Nullable<number>
  headers: Record<string, string | undefined>
  message: string
  response: T

  constructor({
    code,
    status,
    message,
    response,
    headers = {},
  }: {
    code: Nullable<string>
    status: Nullable<number>
    message: string
    response: T
    headers?: Record<string, string | undefined>
  }) {
    super(message)

    this.code = code
    this.status = status
    this.message = message
    this.response = response
    this.headers = headers

    Object.setPrototypeOf(this, RepoError.prototype)
    Error.captureStackTrace(this, this.constructor)
  }
}
